import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import Description from '@/components/ui/Typo/Description'
import H2 from '@/components/ui/Typo/H2'
import {
  IconBackupBlack,
  IconCheckListBlack,
  IconLetterBlack,
  IconPanelBalck,
  IconSslCertificate,
} from '@/res/icons'
import { NAMESPACE_HOSTING } from '@/res/namespaces'

const FreeAllTariffs = () => {
  const { t } = useTranslation(NAMESPACE_HOSTING)

  const items = [
    {
      Icon: IconSslCertificate,
      text: t('decrypt'),
    },
    {
      Icon: IconBackupBlack,
      text: t('backup'),
    },
    {
      Icon: IconLetterBlack,
      text: t('mail_for_domains'),
    },
    {
      Icon: IconPanelBalck,
      text: t('control_panel'),
    },
  ]

  const items2 = [
    {
      Icon: IconCheckListBlack,
      text: t('dns'),
    },
    {
      Icon: IconCheckListBlack,
      text: t('traffic'),
    },
    {
      Icon: IconCheckListBlack,
      text: t('antivirus'),
    },
    {
      Icon: IconCheckListBlack,
      text: t('ftp_ssh'),
    },
  ]

  return (
    <div className="container">
      <div className="mt-12 bg-[#f8f9fc] rounded-2xl py-8 tablet:px-8 small:px-5 px-3 w-full text-[#364364] container">
        <H2 uppercase={false} weight="font-bold" color="text-primary">
          {t('free_all_traffics')}
        </H2>
        <div className="mt-8 tablet:flex">
          <div className="tablet:w-1/2 mr-4">
            {items.map(({ Icon, text }) => (
              <TextRow Icon={Icon} text={text} key={text} />
            ))}
          </div>

          <div className="tablet:w-1/2">
            {items2.map(({ Icon, text }) => (
              <TextRow Icon={Icon} text={text} key={text} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

interface ITextRow {
  Icon: any
  text: string
}

const TextRow: React.FC<ITextRow> = ({ Icon, text }) => {
  return (
    <div className="flex my-2 items-start ">
      <Icon className="mr-4 flex-none" />
      <Description color="text-gray3" weight="font-medium">
        {text}
      </Description>
    </div>
  )
}

export default FreeAllTariffs
